import { createSelector } from 'reselect';

const selectReconciliationRequestItems = (state: any) => state.reconciliationRequestItems;


export const selectReconciliationRequestItemCurrentItem = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.current);

export const selectReconciliationRequestItemsListItems = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.list);

export const selectReconciliationRequestItemItemById = (itemId: any) =>
    createSelector(selectReconciliationRequestItemsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReconciliationRequestItemQueryItems = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.query);

export const selectReconciliationRequestItemCreatedItem = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.create);

export const selectReconciliationRequestItemUpdatedItem = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.update);

export const selectReconciliationRequestItemReadItem = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.read);

export const selectReconciliationRequestItemDeletedItem = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.delete);

export const selectReconciliationRequestItemSearchedItems = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.search);

export const selectReconciliationRequestItemItemsCount = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.count);

export const selectReconciliationRequestItemItemsFilter = createSelector([selectReconciliationRequestItems], (reconciliationRequestItems) => reconciliationRequestItems.filter);